/**
 * スクロール量に応じて、画面内のすべての対象要素をふわっと出し入れする関数（複数対応版・フッター手前100pxで非表示）
 */
export default function initScrollShowElement() {
	const targets = document.querySelectorAll(".js-scroll-show");
	if (targets.length === 0) return; // 1個もなければ終了

	const footer = document.getElementById("footer");

	window.addEventListener("scroll", () => {
		const currentScroll = window.scrollY || document.documentElement.scrollTop;
		let isFooterVisible = false;

		if (footer) {
			const footerRect = footer.getBoundingClientRect();

			// 【フッター手前100px判定】
			// フッターの天辺が「画面の底から50px上」のラインを越えたら発火
			isFooterVisible = footerRect.top < window.innerHeight - 50;
		}

		targets.forEach((target) => {
			if (isFooterVisible || currentScroll <= 50) {
				target.classList.remove("is-show");
			} else {
				target.classList.add("is-show");
			}
		});
	});
}
